import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function RedirectIfAuthenticated({ children }) {
  const auth = localStorage.getItem("auth");

  if (auth) {
    if (auth.terminalUser != null) {
      return <Navigate to="/terminal/claims" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

RedirectIfAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};
